import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      opacity: ".503"
    }, [
      _createElementVNode("g", {
        fill: "#B6B6B6",
        "fill-rule": "nonzero"
      }, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              d: "M8.5 0C13.187 0 17 3.813 17 8.5c0 4.687-3.813 8.5-8.5 8.5C3.813 17 0 13.187 0 8.5 0 3.813 3.813 0 8.5 0zM6.707 5.293c-.39-.39-1.024-.39-1.414 0-.39.39-.39 1.024 0 1.414l2.12 2.121-2.12 2.122-.083.094c-.305.392-.278.96.083 1.32l.094.083c.392.305.96.277 1.32-.083l2.121-2.122 2.122 2.122c.39.39 1.023.39 1.414 0 .39-.39.39-1.024 0-1.414l-2.122-2.122 2.122-2.12.083-.095c.305-.392.277-.96-.083-1.32l-.094-.083c-.393-.305-.96-.278-1.32.083l-2.122 2.12z",
              transform: "translate(-827 -202) translate(342 188) translate(485 14)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }